var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncidentReport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report_problem_24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Light Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.98999L4.46997 19H19.53L12 5.98999ZM11 18V16H13V18H11ZM11 9.99999V14H13V9.99999H11Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Dark Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 21L12 2L23 21H1ZM19.53 19L12 5.99L4.47 19H19.53Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Dark Color_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_3",
    d: "M11 16H13V18H11V16Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Dark Color_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_4",
    d: "M11 10H13V14H11V10Z",
    fill: "white",
    fillOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentReport);
export default __webpack_public_path__ + "static/media/incidentReport.895012efb826e97a4af93ed1667dc14b.svg";
export { ForwardRef as ReactComponent };